
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class NewOrderRequestModel extends Model<NewOrderRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'seller', type: 'SellerDtoModel', isHidden: true, isObject: true, new: () => { return new SellerDtoModel }, properties: () => { return SellerDtoModel.classProperties } },
		{ name: 'company', type: 'CompanyDtoModel', isHidden: true, isObject: true, new: () => { return new CompanyDtoModel }, properties: () => { return CompanyDtoModel.classProperties } },
		{ name: 'contact', type: 'ContactDtoModel', isHidden: true, isObject: true, new: () => { return new ContactDtoModel }, properties: () => { return ContactDtoModel.classProperties } },
		{ name: 'products', type: 'ProductDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductDtoModel }, properties: () => { return ProductDtoModel.classProperties } },
		{ name: 'productPlanDiscontinuations', type: 'ProductPlanDiscontinuationDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanDiscontinuationDtoModel }, properties: () => { return ProductPlanDiscontinuationDtoModel.classProperties } },
		{ name: 'signDate', type: 'Date' },
		{ name: 'agreementId', type: 'string' },
		{ name: 'replies', type: 'ReplyDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ReplyDtoModel }, properties: () => { return ReplyDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public seller?: SellerDtoModel;
	public company?: CompanyDtoModel;
	public contact?: ContactDtoModel;
	public products: ProductDtoModel[];
	public productPlanDiscontinuations: ProductPlanDiscontinuationDtoModel[];
	public signDate?: Date;
	public agreementId?: string;
	public replies: ReplyDtoModel[];
    
	constructor(){
		super();
		this.seller = undefined;
		this.company = undefined;
		this.contact = undefined;
		this.products = [];
		this.productPlanDiscontinuations = [];
		this.signDate = undefined;
		this.agreementId = undefined;
		this.replies = [];
		
	}
	getProperties(){
		return NewOrderRequestModel.classProperties;
	}
}
export class SellerDtoModel extends Model<SellerDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'gormUserId', type: 'string' },
		{ name: 'gormSalesTeamId', type: 'string' }
	];
	[key: string]: any;
	
	public gormUserId?: string;
	public gormSalesTeamId?: string;
    
	constructor(){
		super();
		this.gormUserId = undefined;
		this.gormSalesTeamId = undefined;
		
	}
	getProperties(){
		return SellerDtoModel.classProperties;
	}
}
export class CompanyDtoModel extends Model<CompanyDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'vatNumber', type: 'string' },
		{ name: 'name', type: 'string' },
		{ name: 'address', type: 'string' },
		{ name: 'zipcode', type: 'string' },
		{ name: 'city', type: 'string' },
		{ name: 'countryCode', type: 'string' },
		{ name: 'replies', type: 'ReplyDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ReplyDtoModel }, properties: () => { return ReplyDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public vatNumber: string;
	public name: string;
	public address: string;
	public zipcode: string;
	public city: string;
	public countryCode: string;
	public replies: ReplyDtoModel[];
    
	constructor(){
		super();
		this.vatNumber = '';
		this.name = '';
		this.address = '';
		this.zipcode = '';
		this.city = '';
		this.countryCode = '';
		this.replies = [];
		
	}
	getProperties(){
		return CompanyDtoModel.classProperties;
	}
}
export class ContactDtoModel extends Model<ContactDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'firstName', type: 'string' },
		{ name: 'lastName', type: 'string' },
		{ name: 'phone', type: 'string' },
		{ name: 'mobilePhone', type: 'string' },
		{ name: 'email', type: 'string' }
	];
	[key: string]: any;
	
	public firstName: string;
	public lastName: string;
	public phone: string;
	public mobilePhone: string;
	public email: string;
    
	constructor(){
		super();
		this.firstName = '';
		this.lastName = '';
		this.phone = '';
		this.mobilePhone = '';
		this.email = '';
		
	}
	getProperties(){
		return ContactDtoModel.classProperties;
	}
}
export class ProductDtoModel extends Model<ProductDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'unitPrice', type: 'number' },
		{ name: 'startupAmountInclFirstInvoice', type: 'number' },
		{ name: 'startupAmountExclFirstInvoice', type: 'number' },
		{ name: 'numberOfInstallments', type: 'number' },
		{ name: 'startupInstallments', type: 'number' },
		{ name: 'paymentInterval', type: 'number' },
		{ name: 'productVariantId', type: 'string' },
		{ name: 'generateInvoicesBasedOnProductPlanId', type: 'string' },
		{ name: 'childProducts', type: 'ProductDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductDtoModel }, properties: () => { return ProductDtoModel.classProperties } },
		{ name: 'replies', type: 'ReplyDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ReplyDtoModel }, properties: () => { return ReplyDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public unitPrice: number;
	public startupAmountInclFirstInvoice?: number;
	public startupAmountExclFirstInvoice?: number;
	public numberOfInstallments?: number;
	public startupInstallments?: number;
	public paymentInterval: number;
	public productVariantId?: string;
	public generateInvoicesBasedOnProductPlanId?: string;
	public childProducts: ProductDtoModel[];
	public replies: ReplyDtoModel[];
    
	constructor(){
		super();
		this.unitPrice = 0;
		this.startupAmountInclFirstInvoice = undefined;
		this.startupAmountExclFirstInvoice = undefined;
		this.numberOfInstallments = undefined;
		this.startupInstallments = undefined;
		this.paymentInterval = 0;
		this.productVariantId = undefined;
		this.generateInvoicesBasedOnProductPlanId = undefined;
		this.childProducts = [];
		this.replies = [];
		
	}
	getProperties(){
		return ProductDtoModel.classProperties;
	}
}
export class ProductPlanDiscontinuationDtoModel extends Model<ProductPlanDiscontinuationDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlanId', type: 'string' },
		{ name: 'adjustmentAmount', type: 'number' },
		{ name: 'remainingAmount', type: 'number' }
	];
	[key: string]: any;
	
	public productPlanId?: string;
	public adjustmentAmount: number;
	public remainingAmount: number;
    
	constructor(){
		super();
		this.productPlanId = undefined;
		this.adjustmentAmount = 0;
		this.remainingAmount = 0;
		
	}
	getProperties(){
		return ProductPlanDiscontinuationDtoModel.classProperties;
	}
}
export class ReplyDtoModel extends Model<ReplyDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'questionId', type: 'string' },
		{ name: 'replyData', type: 'string' }
	];
	[key: string]: any;
	
	public questionId?: string;
	public replyData: string;
    
	constructor(){
		super();
		this.questionId = undefined;
		this.replyData = '';
		
	}
	getProperties(){
		return ReplyDtoModel.classProperties;
	}
}

